import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  items: [],
  itemCount: 0,
  subtotal: 0,
  total: 0,
  couponCode: null,
  discountAmount: 0,
  loading: false
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action) => {
      return { ...state, ...action.payload }
    },
    addItem: (state, action) => {
      state.items.push(action.payload)
      state.itemCount += action.payload.quantity
    },
    updateItem: (state, action) => {
      const index = state.items.findIndex(item => item.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      }
    },
    removeItem: (state, action) => {
      const item = state.items.find(i => i.id === action.payload)
      if (item) {
        state.itemCount -= item.quantity
        state.items = state.items.filter(i => i.id !== action.payload)
      }
    },
    clearCart: (state) => {
      state.items = []
      state.itemCount = 0
      state.subtotal = 0
      state.total = 0
      state.couponCode = null
      state.discountAmount = 0
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    }
  }
})

export const { setCart, addItem, updateItem, removeItem, clearCart, setLoading } = cartSlice.actions
export default cartSlice.reducer